import { ActionWithPayload, RehydrateOptions } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { REALITY_CHECK_ACTION_TYPE } from "./reality-check.action";
import { RealityCheckState } from "./reality-check.model";

const initialState: RealityCheckState = {
	isGlobalRealityCheckEnabled: true,
};
const rehydrateOptions: RehydrateOptions<RealityCheckState> = {
	name: "realityCheckReducer",
	excludeProps: ["lastRealityCheck"],
};

export function realityCheckReducer(state = initialState, action: ActionWithPayload): RealityCheckState {
	switch (action.type) {
		case REALITY_CHECK_ACTION_TYPE.saveNextPulse: {
			return updateState(state, {
				nextPulse: Date.now() + action.payload,
			});
		}
		case REALITY_CHECK_ACTION_TYPE.stopTimer: {
			return updateState(state, {
				nextPulse: undefined,
				lastRealityCheck: undefined,
			});
		}
		case REALITY_CHECK_ACTION_TYPE.timerPulse: {
			return updateState(state, {
				triggeredAt: Date.now(),
			});
		}
		case REALITY_CHECK_ACTION_TYPE.timerPulseSuccess: {
			return updateState(state, {
				lastRealityCheck: action.payload,
			});
		}
		case REALITY_CHECK_ACTION_TYPE.setIsGlobalRealityCheckEnabled: {
			return updateState(state, {
				isGlobalRealityCheckEnabled: action.payload,
			});
		}
		default:
			return state;
	}
}

realityCheckReducer.prototype.rehydrateOptions = rehydrateOptions;
